import postgreApiService from "./apiService";
import { RPC_AUTH_ENDPOINTS } from "../endpoints";
import { buildRpcLoginPayload } from "../payload";

export const login = async (payload) => {
    const { email, password } = payload || {};
    const response = await postgreApiService.post(
        RPC_AUTH_ENDPOINTS.LOGIN,
        buildRpcLoginPayload({ username: email, password })
    );
    const data = response?.data;

    // Response is a plain string — either a token or "Status: Pending, Reason: ..."
    if (typeof data === "string") {
        const statusMatch = data.match(/Status:\s*([^,]+)/i);
        if (statusMatch) {
            const reasonMatch = data.match(/Reason:\s*(.*)/i);
            return {
                Status: statusMatch[1].trim(),
                Reason: reasonMatch?.[1]?.trim() || "",
            };
        }
        // Validate it's actually a JWT (xxxxx.yyyyy.zzzzz) before treating as token
        const isJwt = /^[\w-]+\.[\w-]+\.[\w-]+$/.test(data.trim());
        if (isJwt) return { accessToken: data };
        // Plain error string e.g. "Invalid credentials"
        return { success: false, error: data };
    }

    return data || {};
};
